import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="pt-40 md:pt-48 pb-32 px-6 min-h-[70vh] bg-[#FAF6F0]">
      <div className="max-w-xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#A6521B]/12 text-[#A6521B] mb-7">
          <Compass size={24} />
        </div>
        <p className="overline">off the track</p>
        <h1 className="font-display text-5xl md:text-6xl italic font-light mt-4 leading-tight">
          This Page Has Wandered Off
        </h1>
        <p className="mt-6 text-[#23170E]/65 leading-relaxed">
          Even the best guides take a wrong turn now and then. The page you're after isn't here —
          but the safaris certainly are.
        </p>
        <div className="mt-9 flex flex-wrap gap-3 justify-center">
          <Link to="/tours" data-testid="notfound-tours-cta" className="btn-pill btn-pill-primary">
            Browse Safaris <ArrowRight size={16} />
          </Link>
          <Link to="/" data-testid="notfound-home-cta" className="btn-pill btn-pill-outline">
            Back Home
          </Link>
        </div>
      </div>
    </div>
  );
}
